<template lang="pug">

  div

    //-
      -
      - Modal IMPRIMIR
      -
      -

    v-dialog(v-model="show" :max-width="format === 'EXCEL' ? '360px' : '600px'" :persistent="loading")

      .dialogHeader

        .dialogHeaderTitle {{ `Imprimir escala de ${months[month - 1]} de ${year}` }}

        .dialogHeaderClose
          .dialogCloseButton.mdi.mdi-close(@click="close" :class="{ 'dialogCloseButton--loading': loading }")

      v-progress-linear(v-if="loading" indeterminate color="green").mb-0.bgwhite

      .dialogBody

        .dialogBodyContent

          template(v-if="format === 'PDF'")

            .options
              .option
                img(class="optionImg" :class="{ 'optionImg--loading': loading }" :disabled="loading" :src="'/images/periodo-diurno.png'" draggable="false" @click="generateReport('diurno')")
              .option
                img(class="optionImg" :class="{ 'optionImg--loading': loading }" :disabled="loading" :src="'/images/periodo-noturno.png'" draggable="false" @click="generateReport('noturno')")
              .option
                img(class="optionImg" :class="{ 'optionImg--loading': loading }" :disabled="loading" :src="'/images/periodo-ambos.png'" draggable="false" @click="generateReport('todos')")

          template(v-else)

            //- .payrollField.payrollField--last
              label.csLabel
                span(v-html="'Opções'")
              .csFields.csFields--date
                div
                  sos-checkbox(id="resumido" label="" :checked="fullCalendar" @click="onPeriodSettingClick" class="sosCheckbox--payroll")

            div
              label.csLabel.csLabel--heightFix
                span
                  | Período
              .radioButtons.mt-2
                div
                  sos-radio(id="month" name="periodo" label="Apenas o mês" :checked="period" :value="'month'" @click="onPeriodSettingClick").sosCheckbox--print
                .mt-3
                  sos-radio(id="calendar" name="periodo" label="Calendário completo" :checked="period" :value="'calendar'" @click="onPeriodSettingClick").sosCheckbox--print

      template(v-if="format === 'PDF'")

        .dialogFooter.text-right
          sos-button(:disabled="loading" size="medium" color="danger" buttonIconSize="16" @buttonClick="close" buttonLabel="Fechar" buttonIcon="mdi-close")

      template(v-else)

        .dialogFooter.text-right
          sos-button(:disabled="loading" size="medium" color="danger" buttonIconSize="16" @buttonClick="close" buttonLabel="Fechar" buttonIcon="mdi-close").mr-1
          sos-button(:disabled="loading" size="medium" color="purple" buttonIconSize="18" @buttonClick="generateExcel" buttonLabel="Gerar relatório" buttonIcon="mdi-file-document-plus")

    //-
      -
      - Modal AVISO
      -
      -

    confirm-dialog(ref="cdConfirmModal" :title="cdParameters.title" :text="cdParameters.text" :buttonPosition="cdParameters.buttonPosition" :width="cdParameters.width" @close="cdMessageResponse")

    //-
      -
      - Modal INSCRIÇÃO / ASSINATURA
      -
      -

    subscription-modal(:active="subscriptionModal.active" :titulo="subscriptionModal.title" :text="subscriptionModal.message" @close="closeSubscriptionModal")

</template>

<script>

  import { freeVersion } from '@/constants'
  import { apiCheckReportStatus, apiOpenReport } from '@/services/report'

  import { mapState } from 'vuex'

  import SubscriptionModalMixin from '@/mixins/subscription.modal.mixin'
  import confirmDialogMixin from '@/mixins/cd.mixin.js'

  import SosRadio from '@/components/SosRadio'
  import SosButton from '@/components/SosButton'
  import ConfirmDialog from '@/modals/ConfirmDialog'
  import SubscriptionModal from '@/modals/SubscriptionModal'

  export default {
    name: 'RelatorioImprimirEscala',

    components: {
      'sos-radio': SosRadio,
      'sos-button': SosButton,
      'confirm-dialog': ConfirmDialog,
      'subscription-modal': SubscriptionModal,
    },

    mixins: [
      SubscriptionModalMixin,
      confirmDialogMixin,
    ],

    data () {
      return {
        show: false,
        loading: false,

        period: 'month',

        group: false,
        format: null,
        year: null,
        month: null,

        months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      }
    },

    computed: {
      ...mapState(['userSession']),
    },

    methods: {
      //
      // ABRIR
      //

      open (args)
      {
        this.group = args.group || false
        this.format = args.format
        this.year = args.year
        this.month = args.month

        this.show = true
      },

      //
      // FECHAR
      //

      close ()
      {
        if (this.loading) return false

        this.show = false
      },

      //
      // -
      //

      onPeriodSettingClick (value)
      {
        this.period = value
      },

      //
      // -
      //

      showPlanMessage ()
      {
        const planName = this.userSession.planName.name
        const planOrigin = this.userSession.planOrigin

        const talkToOurSupport = `<a href="https://api.whatsapp.com/send?phone=5513992061010&text=Olá, estou no ${planName} e não consigo imprimir a escala. Preciso de ajuda." target="_blank">suporte</a>`
        const textSupport = `<p>Por favor, verifique a situação do seu plano com o nosso ${talkToOurSupport}.</p>`

        if (planOrigin === 'CUSTOM') {
          // Plano personalizado
          this.openSubscriptionModal('Verifique seu plano', `<p>Você está no ${planName} personalizado, mas a impressão de escala não está liberada.</p>${textSupport}`)
        } else if (planOrigin === 'COUPON') {
          // Cupom ativo
          this.openSubscriptionModal('Verifique seu plano', `<p>Você tem um cupom ativo e está no ${planName}, mas a impressão de escala não está liberada.</p>${textSupport}`)
        } else if (planOrigin === 'VINDI' && this.userSession.vindi.paymentStatus === 'paid') {
          // Assinatura ativa na vindi
          this.openSubscriptionModal('Faça um upgrade', `<p>Você está no ${planName}.</p><p>Para imprimir a escala, assine o Plano Bronze ou superior.</p><p>Para mais informações, converse o nosso ${talkToOurSupport}.</p>`)
        } else if (planOrigin === 'VINDI' && this.userSession.vindi.paymentStatus !== 'paid') {
          // Assinatura ativa, mas com alguma pendência ou erro na vindi
          this.openSubscriptionModal('Verifique sua assinatura', `<p>Você é assinante do ${planName}, mas ele não está ativo e a impressão de escala não está liberada.</p>${textSupport}`)
        } else {
          if (!!this.userSession.vindi === true) {
            // Plano da vindi expirado
            this.openSubscriptionModal('Verifique sua assinatura', `<p>Você assinou o ${this.userSession.vindi.planName.name}, mas ele expirou.</p><p>Agora você está no ${planName} e a impressão de escala não está liberada.</p>${textSupport}`)
          } else {
            // Plano gratuíto ou alcançou alguma condição desconhecida
            this.openSubscriptionModal('Verifique seu plano', `<p>Você está no ${planName} e a impressão de escala não está liberada.</p>${textSupport}`)
          }
        }
      },

      //
      // GERAR RELATÓRIO DE ESCALA (PDF)
      //

      async generateReport (turno)
      {
        if (this.loading) return false
        if (this.group === true) return false

        //
        // VERIFICA O USUÁRIO PODE GERAR
        //

        if (freeVersion === false && this.userSession.userCapabilities.relatorioEscala !== true)
        {
          this.showPlanMessage()

          return false
        }

        //
        // ABRE RELATÓRIO
        //

        this.loading = true

        try
        {
          const checkEndpoint = `checkreport/${turno}/${this.$route.params.groupID}/${this.$route.params.scaleID}/${this.month}/${this.year}`
          const generateUrl = `report/${turno}/${this.$route.params.groupID}/${this.$route.params.scaleID}/${this.month}/${this.year}`

          const response = await apiCheckReportStatus(checkEndpoint)

          if (response.code !== 1) {
            this.showMessage(response.title, response.message)
          } else {
            apiOpenReport(generateUrl)
          }
        }
        catch (error)
        {
          this.showMessage('Erro!', 'Não foi possível gerar o relatório. Por favor, atualize a página e tente novamente ou fale com o nosso suporte.')
        }

        this.loading = false
      },

      //
      // GERAR RELATÓRIO DE ESCALA (EXCEL)
      //

      async generateExcel ()
      {
        if (this.loading) return false

        //
        // VERIFICA O USUÁRIO PODE GERAR
        //

        if (freeVersion === false && this.userSession.userCapabilities.relatorioEscala !== true)
        {
          this.showPlanMessage()

          return false
        }

        //
        // ABRE RELATÓRIO
        //

        this.loading = true

        try
        {
          const checkEndpoint = this.group ? `checkgroupscalesreportexcel/${this.$route.params.groupID}/${this.month}/${this.year}/${this.period}` : `checkscalereportexcel/${this.$route.params.groupID}/${this.$route.params.scaleID}/${this.month}/${this.year}/${this.period}`
          const generateUrl = this.group ? `groupscalesreportexcel/${this.$route.params.groupID}/${this.month}/${this.year}/${this.period}` : `scalereportexcel/${this.$route.params.groupID}/${this.$route.params.scaleID}/${this.month}/${this.year}/${this.period}`

          const response = await apiCheckReportStatus(checkEndpoint)

          if (response.code !== 1) {
            this.showMessage(response.title, response.message)
          } else {
            apiOpenReport(generateUrl)
          }
        }
        catch (error)
        {
          this.showMessage('Erro!', 'Não foi possível gerar o relatório. Por favor, atualize a página e tente novamente ou fale com o nosso suporte.')
        }

        this.loading = false
      },
    },
  }

</script>

<style lang="scss">

  .sosCheckbox--print.sosCheckbox .sosCheckboxLabel {
    padding-left: 7px;
    font-size: 15px;
  }

</style>

<style lang="scss" scoped>

  .options {
    margin: -12px;

    font-size: 0;

    .option {
      display: inline-block;
      vertical-align: middle;
      width: 33.3333333333%;
      padding: 12px;
    }
  }

  .optionImg {
    transition-duration: 200ms;
    transition-property: transform, filter;

    cursor: pointer;

    border-radius: 5px;
    box-shadow: 2px 2px 10px -5px rgba(0, 0, 0, 0.7);

    &:hover {
      transform: scale(1.03);
    }

    &:active {
      transform: scale(0.97);
    }

    &--loading {
      cursor: default;
      filter: grayscale(1);

      &:hover {
        transform: none;
      }

      &:active {
        transform: none;
      }
    }
  }

  .bgwhite {
    background-color: #FFFFFF;
  }

</style>
